module.exports = __webpack_public_path__ + "static/media/block_icon_audio.876befd1.svg";